// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__LpetE","footer":"ModalError_footer__13WV1"};